import Spinner from "@/components/common/Spinner";
import UnauthorizedPage from "@/components/pages/UnauthorizedPage";
import { useSetRoles } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { useStudiesCopy } from "@/features/i18n/studiesCopy";
import { useAuth } from "@/utils/auth";
import { useNav } from "@/utils/nav";
import { Outlet, createFileRoute } from "@tanstack/react-router";

function StudiesLayout() {
    const copy = useStudiesCopy();
    useNav([{ route: { to: "/studies" }, label: copy.studies }]);
    const auth = useAuth();
    const { isPending } = useSetRoles();

    if (isPending && !auth.roles?.isAdmin && !auth.roles?.isManager) {
        return (
            <section className="flex justify-center items-center p-8 w-full">
                <Spinner />
            </section>
        );
    }

    if (auth.roles?.isAdmin || auth.roles?.isManager) {
        return <Outlet />;
    }

    return <UnauthorizedPage message={copy.unauthorizedMessage} />;
}

export const Route = createFileRoute("/_app/studies")({
    component: StudiesLayout,
});
